/**
 * Permission codes.
 *
 * GENERATED FILE - do not edit by hand.
 *
 * Emitted from Microcredit.Access.Domain.Permissions by
 * tools/Microcredit.CodegenConstants. CI regenerates it and fails on a diff, so a
 * permission renamed on the server cannot silently leave a menu item visible here.
 *
 * The list is presentation input only. The server re-checks every command against the
 * live catalogue, so a stale copy here can hide an action but can never grant one.
 */

export const PERMISSIONS = {
  admin: {
    accessReview: 'admin.access.review',
    allBranches: 'admin.access.all_branches',
    approvalPolicyManage: 'admin.approval_policy.manage',
    approvalPolicyManageApprove: 'admin.approval_policy.manage.approve',
    branchManage: 'admin.branch.manage',
    branchManageApprove: 'admin.branch.manage.approve',
    branchView: 'admin.branch.view',
    holidayManage: 'admin.holiday.manage',
    mfaReset: 'admin.mfa.reset',
    mfaResetApprove: 'admin.mfa.reset.approve',
    parameterManage: 'admin.parameter.manage',
    parameterManageApprove: 'admin.parameter.manage.approve',
    parameterView: 'admin.parameter.view',
    permissionView: 'admin.permission.view',
    roleAssign: 'admin.role.assign',
    roleAssignApprove: 'admin.role.assign.approve',
    roleManage: 'admin.role.manage',
    roleManageApprove: 'admin.role.manage.approve',
    roleView: 'admin.role.view',
    sodOverride: 'admin.sod.override',
    sodOverrideApprove: 'admin.sod.override.approve',
    userCreate: 'admin.user.create',
    userCreateApprove: 'admin.user.create.approve',
    userDisable: 'admin.user.disable',
    userLock: 'admin.user.lock',
    userUnlock: 'admin.user.unlock',
    userUnlockApprove: 'admin.user.unlock.approve',
    userUpdate: 'admin.user.update',
    userUpdateApprove: 'admin.user.update.approve',
    userView: 'admin.user.view',
  },
  aml: {
    caseManage: 'aml.case.manage',
    caseView: 'aml.case.view',
    ctrExport: 'aml.ctr.export',
    ctrThresholdManage: 'aml.ctr_threshold.manage',
    ctrThresholdManageApprove: 'aml.ctr_threshold.manage.approve',
    ctrView: 'aml.ctr.view',
    customerScreen: 'aml.customer.screen',
    monitoringRun: 'aml.monitoring.run',
    pepFlag: 'aml.pep.flag',
    pepFlagApprove: 'aml.pep.flag.approve',
    retentionManage: 'aml.retention.manage',
    riskView: 'aml.risk.view',
    sanctionsImport: 'aml.sanctions.import',
    screeningReview: 'aml.screening.review',
    str: 'aml.str',
    watchlistManage: 'aml.watchlist.manage',
  },
  compliance: {
    assumptionsView: 'compliance.assumptions.view',
  },
  customers: {
    biometricEnrol: 'customers.biometric.enrol',
    biometricEnrolApprove: 'customers.biometric.enrol.approve',
    biometricRevoke: 'customers.biometric.revoke',
    biometricView: 'customers.biometric.view',
    blacklist: 'customers.blacklist',
    blacklistApprove: 'customers.blacklist.approve',
    create: 'customers.create',
    documentUpload: 'customers.document.upload',
    documentView: 'customers.document.view',
    export: 'customers.export',
    insiderFlag: 'customers.insider.flag',
    kycApprove: 'customers.kyc.approve',
    kycApproveCountersign: 'customers.kyc.approve.approve',
    kycSubmit: 'customers.kyc.submit',
    mediaCapture: 'customers.media.capture',
    mediaView: 'customers.media.view',
    piiView: 'customers.pii.view',
    riskOverride: 'customers.risk.override',
    riskOverrideApprove: 'customers.risk.override.approve',
    statusChange: 'customers.status.change',
    update: 'customers.update',
    view: 'customers.view',
    viewAllBranches: 'customers.view.all_branches',
  },
  documents: {
    view: 'documents.view',
  },
  groups: {
    create: 'groups.create',
    createApprove: 'groups.create.approve',
    healthAttest: 'groups.health.attest',
    healthAttestApprove: 'groups.health.attest.approve',
    healthConfig: 'groups.health.config',
    healthConfigApprove: 'groups.health.config.approve',
    healthView: 'groups.health.view',
    leaderChange: 'groups.leader.change',
    leaderChangeApprove: 'groups.leader.change.approve',
    locationManage: 'groups.location.manage',
    locationManageApprove: 'groups.location.manage.approve',
    meetingRecord: 'groups.meeting.record',
    meetingSchedule: 'groups.meeting.schedule',
    memberAdd: 'groups.member.add',
    memberExit: 'groups.member.exit',
    officerAssign: 'groups.officer.assign',
    officerAssignApprove: 'groups.officer.assign.approve',
    update: 'groups.update',
    view: 'groups.view',
  },
  ledger: {
    accountManage: 'ledger.account.manage',
    accountManageApprove: 'ledger.account.manage.approve',
    accountView: 'ledger.account.view',
    dayClose: 'ledger.day.close',
    dayOpen: 'ledger.day.open',
    dayReopen: 'ledger.day.reopen',
    dayReopenApprove: 'ledger.day.reopen.approve',
    driftResolve: 'ledger.drift.resolve',
    driftView: 'ledger.drift.view',
    journalManual: 'ledger.journal.manual',
    journalManualApprove: 'ledger.journal.manual.approve',
    journalReverse: 'ledger.journal.reverse',
    journalReverseApprove: 'ledger.journal.reverse.approve',
    journalView: 'ledger.journal.view',
    periodClose: 'ledger.period.close',
    periodReopen: 'ledger.period.reopen',
    periodReopenApprove: 'ledger.period.reopen.approve',
    provisionRun: 'ledger.provision.run',
    trialBalanceView: 'ledger.trialbalance.view',
  },
  loans: {
    accountOpen: 'loans.account.open',
    apply: 'loans.apply',
    appraise: 'loans.appraise',
    approve: 'loans.approve',
    approveCountersign: 'loans.approve.approve',
    classificationConfig: 'loans.classification.config',
    classificationConfigApprove: 'loans.classification.config.approve',
    classificationOverride: 'loans.classification.override',
    classificationOverrideApprove: 'loans.classification.override.approve',
    disburse: 'loans.disburse',
    disburseApprove: 'loans.disburse.approve',
    disclosureConfig: 'loans.disclosure.config',
    disclosureConfigApprove: 'loans.disclosure.config.approve',
    disclosureGenerate: 'loans.disclosure.generate',
    guaranteeOffset: 'loans.guarantee.offset',
    guaranteeOffsetApprove: 'loans.guarantee.offset.approve',
    penaltyWaive: 'loans.penalty.waive',
    penaltyWaiveApprove: 'loans.penalty.waive.approve',
    productManage: 'loans.product.manage',
    productManageApprove: 'loans.product.manage.approve',
    productView: 'loans.product.view',
    repaymentPost: 'loans.repayment.post',
    repaymentReverse: 'loans.repayment.reverse',
    repaymentReverseApprove: 'loans.repayment.reverse.approve',
    restructure: 'loans.restructure',
    restructureApprove: 'loans.restructure.approve',
    scheduleView: 'loans.schedule.view',
    statementView: 'loans.statement.view',
    view: 'loans.view',
    writeOff: 'loans.writeoff',
    writeOffApprove: 'loans.writeoff.approve',
  },
  moduleNames: {
    admin: 'admin',
    aml: 'aml',
    compliance: 'compliance',
    customers: 'customers',
    documents: 'documents',
    groups: 'groups',
    ledger: 'ledger',
    loans: 'loans',
    notifications: 'notifications',
    ops: 'ops',
    reports: 'reports',
    savings: 'savings',
    sync: 'sync',
    takeOn: 'takeon',
    teller: 'teller',
  },
  notifications: {
    outboxRetry: 'notifications.outbox.retry',
    outboxView: 'notifications.outbox.view',
    preferenceManage: 'notifications.preference.manage',
    sendManual: 'notifications.send.manual',
    senderManage: 'notifications.sender.manage',
    senderManageApprove: 'notifications.sender.manage.approve',
    templateManage: 'notifications.template.manage',
    templateManageApprove: 'notifications.template.manage.approve',
    templateView: 'notifications.template.view',
  },
  ops: {
    auditExport: 'ops.audit.export',
    auditVerify: 'ops.audit.verify',
    auditView: 'ops.audit.view',
    configView: 'ops.config.view',
    healthView: 'ops.health.view',
    incidentManage: 'ops.incident.manage',
    incidentView: 'ops.incident.view',
    jobsTrigger: 'ops.jobs.trigger',
    jobsView: 'ops.jobs.view',
    outboxRetry: 'ops.outbox.retry',
    outboxView: 'ops.outbox.view',
  },
  reports: {
    bureauExtract: 'reports.bureau.extract',
    collectionsView: 'reports.collections.view',
    exceptionView: 'reports.exception.view',
    export: 'reports.export',
    exportBulk: 'reports.export.bulk',
    groupHealthView: 'reports.group_health.view',
    officerPerformanceView: 'reports.officer_performance.view',
    parView: 'reports.par.view',
    portfolioView: 'reports.portfolio.view',
    regulatoryGenerate: 'reports.regulatory.generate',
    statementGenerate: 'reports.statement.generate',
    trialBalanceView: 'reports.trialbalance.view',
  },
  savings: {
    accountOpen: 'savings.account.open',
    close: 'savings.close',
    closeApprove: 'savings.close.approve',
    depositPost: 'savings.deposit.post',
    dormancyManage: 'savings.dormancy.manage',
    holdPlace: 'savings.hold.place',
    holdRelease: 'savings.hold.release',
    interestPost: 'savings.interest.post',
    productManage: 'savings.product.manage',
    productManageApprove: 'savings.product.manage.approve',
    productView: 'savings.product.view',
    securityDepositTopUp: 'savings.security_deposit.topup',
    statementView: 'savings.statement.view',
    transferPost: 'savings.transfer.post',
    view: 'savings.view',
    withdrawalPost: 'savings.withdrawal.post',
    withdrawalPostApprove: 'savings.withdrawal.post.approve',
  },
  sync: {
    changesPull: 'sync.changes.pull',
    deviceRegister: 'sync.device.register',
    deviceRevoke: 'sync.device.revoke',
    deviceRevokeApprove: 'sync.device.revoke.approve',
    exceptionResolve: 'sync.exception.resolve',
    exceptionView: 'sync.exception.view',
    geofenceExceptionView: 'sync.geofence_exception.view',
    mutationsPush: 'sync.mutations.push',
  },
  takeOn: {
    batchApprove: 'takeon.batch.manage.approve',
    batchManage: 'takeon.batch.manage',
    batchView: 'takeon.batch.view',
  },
  teller: {
    denominationRecord: 'teller.denomination.record',
    depositPost: 'teller.deposit.post',
    eodSubmit: 'teller.eod.submit',
    eodSubmitApprove: 'teller.eod.submit.approve',
    fieldTillAssign: 'teller.field_till.assign',
    limitOverride: 'teller.limit.override',
    limitOverrideApprove: 'teller.limit.override.approve',
    reconcile: 'teller.reconcile',
    repaymentPost: 'teller.repayment.post',
    sessionClose: 'teller.session.close',
    sessionOpen: 'teller.session.open',
    tillView: 'teller.till.view',
    vaultTransfer: 'teller.vault.transfer',
    vaultTransferApprove: 'teller.vault.transfer.approve',
    vaultView: 'teller.vault.view',
    verificationPerform: 'teller.verification.perform',
    verificationReview: 'teller.verification.review',
    withdrawalPost: 'teller.withdrawal.post',
  },
} as const

type PermissionGroup = typeof PERMISSIONS
type PermissionValues<T> = T[keyof T]

export type PermissionCode = PermissionValues<{
  [K in keyof PermissionGroup]: PermissionValues<PermissionGroup[K]>
}>

/**
 * Held by head-office roles that may operate outside their home branch. The branch selector
 * is only offered to a user whose branch list has more than one entry, which the server decides.
 */
export const ALL_BRANCHES_PERMISSION = 'access.branches.all'
